import User from '@/store/models/user'
import * as api from '@/api/auth'
import { actions as authActions } from '@/store/modules/auth'
import { services } from '@billow/js-helpers'
import { first, find } from 'lodash'


export let state = {
  user: new User,
  authenticated: null
}

export let mutations = {
  setUser: (state, payload) => state.user = (new User).hydrate(payload),

  username: ({ user }, payload) => user.username = payload,
  password: ({ user }, payload) => user.password = payload,
  authenticated: (state) => state.authenticated = true,
  unauthenticated: (state) => state.authenticated = false,
  loggedIn: (state) => state.authenticated = true
}

export let actions = {
  user: ({ commit }) => new Promise((resolve, reject) => {
    api.load(response => {
      let user = response.data
      if (!user.roles.some(role => role.name === 'admin')) {
        reject()
        return
      }
      commit('setUser', user)
      commit('authenticated')
      resolve()
    }, () => {
      commit('unauthenticated')
      reject()
    })
  }),

  /**
   * Import the signout action from the main auth module.
   */
  signOut: ({}) => new Promise((resolve, reject) => {

  }),


  login: ({ state, dispatch, commit }) => new Promise((resolve, reject) => {
    api.login(state.user, ({ data }) => {
      services.auth.setToken(
        data.access_token
      ).then(() => {
        dispatch('loadUser').then(() => {
          resolve(data)
        }).catch(error => reject(error))
      })
    }, error => reject(error))
  }),

  logout: ({ commit }) => new Promise((resolve) => {
    services.auth.destroyToken()
    resolve(() => commit('unauthenticated'))
  }),

  loadUser: ({ commit }) => new Promise((resolve, reject) => {
    api.loadUser(({ data }) => {
      commit('setUser', data)
      resolve(data)
    }, error => reject(error))
  }),

  checkAuth: ({ commit }) => {
    if (services.auth.token()) {
      commit('authenticated')
    } else {
      commit('unauthenticated')
    }
  }
}

export let getters = {
  user: state => state.user,
  authenticated: state => state.authenticated
}


